var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionnaireAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1C13.0333 1 10.1332 1.87973 7.66645 3.52796C5.19972 5.17618 3.27713 7.51886 2.14181 10.2597C1.0065 13.0006 0.709449 16.0166 1.28823 18.9264C1.86701 21.8361 3.29562 24.5088 5.3934 26.6066C7.49119 28.7044 10.1639 30.133 13.0737 30.7118C15.9834 31.2906 18.9994 30.9935 21.7403 29.8582C24.4812 28.7229 26.8238 26.8003 28.4721 24.3336C30.1203 21.8668 31 18.9667 31 16C31 12.0218 29.4197 8.20644 26.6066 5.3934C23.7936 2.58035 19.9783 1 16 1Z",
    fill: "#EFE8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H12C10.4087 18 8.88258 18.6321 7.75736 19.7574C6.63214 20.8826 6 22.4087 6 24V26.71C5.99999 26.8544 6.03127 26.9972 6.09169 27.1284C6.15211 27.2596 6.24023 27.3761 6.35 27.47C9.05195 29.7385 12.467 30.982 15.995 30.982C19.523 30.982 22.938 29.7385 25.64 27.47C25.7498 27.3761 25.8379 27.2596 25.8983 27.1284C25.9587 26.9972 25.99 26.8544 25.99 26.71V24C25.99 22.4104 25.3592 20.8858 24.2362 19.7609C23.1131 18.636 21.5896 18.0026 20 18Z",
    fill: "#7F43FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16C18.7614 16 21 13.7614 21 11C21 8.23858 18.7614 6 16 6C13.2386 6 11 8.23858 11 11C11 13.7614 13.2386 16 16 16Z",
    fill: "#7F43FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaireAvatar);
export default __webpack_public_path__ + "static/media/questionnaire-avatar.51b752f66ff353919ac831a1c3849d43.svg";
export { ForwardRef as ReactComponent };